import React, {useCallback, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyFormsComponent.metadata.json5';
import styles from "./PolicyFormsComponent.module.scss";


const getCellValue = (rowData, rowIndex, rowProperty) => {
    return (
        <span>
            {rowData[rowProperty.id] ? rowData[rowProperty.id] : '-' }
        </span>
    );
};


function PolicyFormsComponent(props) {
    const { value: currentPeriodDetails } = props;
    if (_.isEmpty(currentPeriodDetails) || currentPeriodDetails === undefined) {
        return null;
    }

    const getLobData = (currentDetails) => {
        const { productName } = currentDetails;
        let lData = '';
        // eslint-disable-next-line default-case
        switch (productName) {
            case 'Commercial Property':
                lData = currentDetails.lobs.commercialProperty;
                break;
            case 'Residential':
            case 'Marine':
            case 'Farm':
                lData = currentDetails.lobs.homeOwners;
                break;    
              }
        return lData;
    };

    const lobData = getLobData(currentPeriodDetails);

    /* const generateLiabilityTableOverrides = useCallback(() => {
        return {
             coverageColumn: { onCell: getCellCoverageName },
             limitColumn: { onCell: getCellCoverageLimit,
                header: currentPeriodDetails.productName === 'Commercial Property'? "Total Limit" : "Limit"
             },
             aggregateLimitColumn: { onCell: getCellAggregateLimit, 
                visible: currentPeriodDetails.productName === 'Commercial Property',
             },
             deductibleColumn: { onCell: getCellCoverageDeductible } 
        };
    }, [policyLiabilityCoverables]); */

    const policyForms = useMemo(() => {
        return lobData.policyForms;
    }, [currentPeriodDetails]);


    const overrides = {
        policyFormTable: {
            data: policyForms
        },
        //coverageColumn: { onCell: getCellCoverageName },
        //limitColumn: { onCell: getCellCoverageLimit},
        noFormLabel: {
            visible: _.isEmpty(policyForms)
        },
    };

    const resolvers = {
        resolveCallbackMap:{
           getCellValue: getCellValue
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={lobData}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}


PolicyFormsComponent.propTypes = {
    value: PropTypes.shape({})
};

PolicyFormsComponent.defaultProps = {
    value: {
        // lobData: {},
        // liabilityCoverageDTOs: [],
        // liabilityExtensions: []
    }
};

export default PolicyFormsComponent;
